<template>
  <section>
    <v-stepper v-model="stepper">
      <v-stepper-header>
        <v-stepper-step :complete="stepper > 1" editable step="1">Client</v-stepper-step>
        <v-stepper-step :complete="stepper > 2" :editable="stepper > 2" step="2">Practice area & Session type</v-stepper-step>
        <v-stepper-step :complete="stepper > 3" :editable="stepper > 3" step="3">Date & Time</v-stepper-step>
        <v-stepper-step step="4">Tutor & AN</v-stepper-step>
        <v-stepper-step step="5">Additional</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1" class="blur">
          <v-card>
            <v-toolbar dense color="blur">
              <v-text-field v-model="students.search" autofocus placeholder="Type to search..." hide-details solo-inverted dense/>
            </v-toolbar>
            <v-data-table :headers="students.headers" :items="students.items" :search="students.search" dense>
              <template v-slot:item.study_groups="{ value }">
                <div v-for="(item, idx) in value" :key="idx">{{ item.name }}</div>
              </template>
              <template v-slot:item.session_limits="{ value }">
                <div v-for="(item, idx) in value" :key="idx">{{ item.short_name }} - {{ item.count }}</div>
              </template>
              <template v-slot:item.actions="{item}">
                <v-btn small class="box-shadow" color="primary" @click="selectStudent(item)">select</v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2">
          <template v-if="selected_student && selected_student.session_limits.length > 0">
            <v-select label="Practice areas" v-model="practice_area_id"
                      :items="practice_areas"
                      item-text="name"
                      item-value="id"
                      :error-messages="api_errors['practice_area_id']"
            />
            <v-select v-model="session_type_id"
                      :items="selected_student.session_limits.filter(item => item.status === 'independent')"
                      label="Session type"
                      item-text="name"
                      item-value="id"
                      :error-messages="api_errors['session_type_id']"
            >
              <template v-slot:item="{item}">
                {{ item.name }}  <v-chip class="ma-2">{{ item.count }}</v-chip>
              </template>
            </v-select>

            <v-divider/>
            <v-card-actions class="justify-center">
              <v-btn class="box-shadow" color="primary" @click="this.stepper--">Back</v-btn>
              <v-btn class="box-shadow" color="success" :disabled="!practice_area_id || !session_type_id"
                     @click="submitSecondStep">Continue</v-btn>
            </v-card-actions>
          </template>
          <template v-else>

          </template>

        </v-stepper-content>

        <v-stepper-content step="3">

          <v-toolbar flat color="white" class="box-shadow">
            <v-btn color="primary" class="box-shadow" @click="setToday">Today</v-btn>
            <v-spacer/>
            <v-btn text @click="$refs.gsCreateEventCalendar.prev()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title class="mx-3">
              {{ $moment(this.focus).format('MMMM YYYY') }}
            </v-toolbar-title>
            <v-btn text @click="$refs.gsCreateEventCalendar.next()">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <v-spacer/>
            <v-toolbar-items style="height: auto">
              <v-select
                  v-model="type"
                  :items="type_options"
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  hide-details
                  single-line
                  outlined
                  dense
              ></v-select>
            </v-toolbar-items>
          </v-toolbar>

          <v-calendar ref="gsCreateEventCalendar"
                      :now="today"
                      :type="type"
                      v-model="focus"
                      color="primary"
                      :events="events"
                      :event-color="getEventColor"
                      :interval-minutes="90"
                      :interval-count="16"
                      :interval-height="40"
                      @click:more="viewMore"
                      @click:date="viewMore"
                      @click:day="viewMore"
                      @click:event="selectSlot"
                      @change="loadAvailableDates"
          ></v-calendar>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-select label="Tutor" v-model="tutor_id"
                    :items="available_tutors"
                    color="primary"
                    item-text="nickname"
                    item-value="id"
          >
            <template v-slot:item="{item}">
              <v-list-item-action>{{ item.nickname }}</v-list-item-action>
              <v-list-item-content>
                <div class="" v-html="item.summary"></div>
              </v-list-item-content>
            </template>
          </v-select>

          <v-select label="Mock"
                    color="primary"
                    v-model="mock"
                    :items="staff_available_mocks"
                    item-color="success"
                    item-text="name"
                    item-value="id"
                    return-object
          >
            <template v-slot:item="{ item }">
              {{ item.practice_area.name }}/{{ item.session_type.name }}/{{ item.name }}
            </template>

            <template v-slot:selection="{ item }">
              {{ item.practice_area.name }}/{{ item.session_type.name }}/{{ item.name }}
            </template>
          </v-select>

          <v-divider/>
          <v-btn block color="success" :disabled="!tutor_id || !mock" @click="createEvent">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-content step="5">
          <v-list-item three-line v-if="main_session">
            <v-list-item-content>
              <v-list-item-title v-text="main_session.name"/>
              <v-list-item-subtitle>
                Start at: {{ $moment(main_session.start).format('DD MMMM YYYY hh:mm A') }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn small class="box-shadow mt-3" color="success" target="_blank"
                     :to="{name: 'Session', params: {session_id: main_session.id}}">
                open session
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider/>
          <!--            children_session-->
          <template v-if="children_session">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title v-text="children_session.name"/>
                <v-list-item-subtitle>
                  Start at: {{ $moment(children_session.start).format('DD MMMM YYYY hh:mm A') }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn small class="box-shadow mt-3" color="success"
                       :to="{name: 'Session', params: {session_id: children_session.id}}">
                  open session
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider/>
          </template>

          <template v-if="mock && !children_session && mock.children.length > 0">
            <v-subheader>An additional mocks is available. Want to book?</v-subheader>
            <v-list-item>
              <v-list-item-icon><v-icon color="primary">mdi-school</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-select v-model="children_mock"
                          :items="mock.children"
                          item-text="full_name"
                          item-value="id"
                          hide-details
                          return-object
                          outlined
                          dense
                ></v-select>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn dark small color="primary" class="box-shadow" @click="createChildrenSession">Book</v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider/>
          </template>

          <v-card-text>
            <v-btn class="box-shadow my-3" color="primary" @click="stepper = 1" block>Reserve next</v-btn>
            <v-btn class="box-shadow my-3" color="primary" :to="{name: 'Sessions'}" block>Open sessions</v-btn>
          </v-card-text>
        </v-stepper-content>
      </v-stepper-items>

    </v-stepper>
  </section>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  data: () => ({
    stepper: 1,
    students: {
      headers: [
        { text: 'Name', value: 'full_name'},
        { text: 'Email', value: 'email'},
        { text: 'Study groups', value: 'study_groups'},
        { text: 'Session limits', value: 'session_limits'},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      search: '',
    },
    //step 2
    selected_student: null,
    practice_area_id: null,
    session_type_id: null,
    available_mocks: [],
    //step 3
    today: '',
    focus: '',
    type: 'month',
    type_options: [
      { value: 'month', label: 'Month'},
      { value: 'week', label: 'Week'},
      { value: 'day', label: 'Day'},
    ],
    available_dates_load_options: null,
    available_dates: [],
    selected_slot: null,
    //step4
    available_tutors:[],
    tutor_id: null,
    staff_available_mocks: [],
    mock: null,
    children_mock: null,
    //step5
    main_session: null,
    children_session: null,
    api_errors: [],
  }),
  computed: {
    ...mapGetters({practice_areas: 'getPracticeAreas'}),
    events: function () {
      let items = []
      if (this.available_dates && this.available_dates.length > 0) {
        let mapped_items = this.available_dates.map(item => ({...item}))
        items.push(...mapped_items)
      }

      return items
    },
    attendance_note_available: function () {
      if(!this.mock) return false
      return this.mock.children.length > 0
    }
  },
  watch: {
    tutor_id: function (val) {
      if(val !== null) {
        this.loadAvailableTutorMocks()
      }
    },
    stepper: function (val) {
      if (val === 1) {
        this.selected_student = null
        this.practice_area_id = null
        this.session_type_id = null
        this.tutor_id = null
        this.mock = null
        this.main_session = null
        this.children_session = null
      }
      if (val === 2) {
        this.practice_area_id = null
        this.session_type_id = null
        this.tutor_id = null
        this.mock = null
      }
    }
  },
  created() {
    this.loadStudents()
    this.today = this.$currentTime().format('YYYY-MM-DD')
    this.focus = this.$currentTime().format('YYYY-MM-DD')
  },
  methods: {
    async loadStudents() {
      this.students.items = await this.axios.get(`api/students`).then(({data}) => data.data)
    },
    selectStudent(item) {
      this.selected_student = item
      this.stepper++
    },
    submitSecondStep() {
      this.axios.get(`api/sessions/available-mocks`, {params:{
          user_id: this.selected_student ? this.selected_student.id : null,
          practice_area_id: this.practice_area_id,
          session_type_id: this.session_type_id,
          check_limit: '1',
        }})
          .then(({data}) => {
            this.available_mocks = data.data
            this.loadAvailableDates(this.available_dates_load_options)
            this.stepper++
          })
          .catch(errors => { this.api_errors = errors.response.data.errors })
    },
    closeDialog () {
      this.$emit('change', false)
    },

    setToday() {
      this.today = this.$currentTime().format('YYYY-MM-DD')
      this.focus = this.$currentTime().format('YYYY-MM-DD')
    },
    viewMore({date}) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor() {
      // getEventColor(session) {
      // let diff = this.$moment(session.date).diff(this.$currentTime().format())
      // return diff > 0 ? 'primary' : 'secondary'
      return 'primary'
    },
    loadAvailableDates({start, end}) {
      this.available_dates_load_options = {start, end}
      if(this.available_mocks.length === 0) return;
      this.axios.get(`api/sessions/available-slots`, {params: {
          user_id: this.selected_student ? this.selected_student.id : null,
          session_type_id: this.session_type_id,
          practice_area_id: this.practice_area_id,
          mocks: this.available_mocks.map(item => item.id),
          date_from: start.date,
          date_to: end.date,
        }})
          .then(({data}) => { this.available_dates = data.data })
          .catch(errors => { this.api_errors = errors.response.data.errors })
    },
    selectSlot({event}) {
      this.selected_slot = event
      this.available_tutors = []
      this.tutor_id = null
      this.staff_available_mocks = []
      this.mock = null

      this.axios.get(`api/sessions/available-tutors`, {params: {
          user_id: this.selected_student ? this.selected_student.id : null,
          practice_area_id: this.practice_area_id,
          session_type_id: this.session_type_id,
          mocks: this.available_mocks.map(item => item.id),
          start: event.start,
          end: event.end,

          //deprecated
          date: event.date,
          time_start: event.time_start,
          time_end: event.time_end,
        }})
          .then(({data}) => {
            this.available_tutors = data.data
            this.stepper++
          })
          .catch(errors => {
            this.api_errors = errors.response.data.errors
            this.available_tutors = []
          })
    },
    loadAvailableTutorMocks() {
      this.axios.get(`api/sessions/available-tutor-mocks`, { params: {
          user_id: this.selected_student ? this.selected_student.id : null,
          tutor_id: this.tutor_id,
          mocks: this.available_mocks.map(item => item.id),
        }})
          .then(response => {this.staff_available_mocks = response.data.data})
          .catch(errors => {this.api_errors = errors.response.data.errors})
    },
    createEvent() {
      this.api_errors = []
      this.app_loading = true
      this.axios.post(`api/sessions`, {
        user_id: this.selected_student ? this.selected_student.id : null,
        practice_area_id: this.practice_area_id,
        session_type_id: this.session_type_id,
        mock_id: this.mock ? this.mock.id : null,
        tutor_id: this.tutor_id,
        start: this.selected_slot.start,
        end: this.selected_slot.end,

        //deprecated
        date: this.selected_slot.date,
        time_start: this.selected_slot.time_start,
        time_end: this.selected_slot.time_end,
      })
          .then(({data}) => {
            this.main_session = data.data
            this.stepper++

            // this.$router.push({name: 'Course sessions', params: this.$route.params})
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {
            this.app_loading = false
          })
    },
    createChildrenSession() {
      this.api_errors = []
      this.app_loading = true
      this.axios.post(`api/sessions`, {
        user_id: this.selected_student ? this.selected_student.id : null,
        parent_session_id: this.main_session.id,
        session_type_id: this.children_mock.session_type_id,
        practice_area_id: this.children_mock.practice_area_id,
        mock_id: this.children_mock.id,
        start: this.main_session.start,
        end: this.main_session.end,
      })
          .then(({data}) => {
            this.children_session = data.data
            this.$notify('Success!','success')
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {this.app_loading = false})
    }

  }
}
</script>